import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

// 获取LG呼叫标签
export const getLGDialTag = (data: any = {}) => {
  const url = getAgsApiUrl('v2', 'dail-tag');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};
